import {fetchApi} from '../../utils/functions';

export const getRealPerformanceService = async (planId: number) =>
    fetchApi(`plan/v1/plans/${planId}/performance`, 'get', {});

export const getPlanSummaryService = async (planId: number) =>
    fetchApi(`plan/v1/plans/${planId}/summary?include=GoalSummary,Probability,Scenarios`, 'get', {});

export default getPlanSummaryService;
